import { ADD_WORKSPACE_FIELD_NAME } from '../../AddWorkspaceModal.constants';
import { ADD_WORKSPACE_MIN_LENGTH_ERROR_CODE } from '../../errors/add-workspace-error-codes';
export const workspaceNameValidator = (value) => {
    // If value still not in form state or if value is empty string, return error
    // The field does not have validation rules so nothing to display under the input
    // if this changes, make sure the 'code' returned here is added to the `errors.json` files for the supported languages
    if (!value) {
        return {
            isValid: false,
            errors: [
                {
                    code: ADD_WORKSPACE_MIN_LENGTH_ERROR_CODE,
                    message: '',
                    path: [ADD_WORKSPACE_FIELD_NAME],
                },
            ],
        };
    }
    return {
        isValid: true,
        errors: [],
    };
};
